import React from 'react';
import { Img1, Img2, Img3 } from '../../images';

const IconProgressBar = ({ indexProgress }) => {
    const widthIcon = 65;
    const arrIcons = [
        <Img1  indexProgress={indexProgress} width={widthIcon} />,
        <Img2  indexProgress={indexProgress} width={widthIcon} />,
        <Img3  indexProgress={indexProgress} width={widthIcon}/>
    ];

    return(
        <div className="sg-iconbar-ca">
            {arrIcons.map((icon,index)  => {
                return <div id={index} className="iconbar-ca">{icon}</div>
            })}
        </div>
    );
}

export {IconProgressBar};
